import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { IColumnDefinition } from '@common/models/column-definition';

@Injectable()
export class ArrearsTransactionTableColumnsHttpService {

  constructor(private readonly http: HttpClient,
    private readonly urlBuilderService: UrlBuilderService) { }

  getAllTableColumns(): Observable<IColumnDefinition[]> {
    const url = this.urlBuilderService.getUrl('debtanalysis/table/columns');
    return this.http
      .get<IColumnDefinition[]>(url)
      .pipe(map(table => table || undefined));
  }
}
